// src/Slices/AgeSlice.js
import { createSlice } from "@reduxjs/toolkit";

const ageSlice = createSlice({
  name: "AgeData",
  initialState: {
    selectedAge: null,
  },
  reducers: {
    setSelectedAge: (state, action) => {
      state.selectedAge = action.payload;
    },
  },
});

export const { setSelectedAge } = ageSlice.actions;
export default ageSlice.reducer;
